var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgK12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k12_svg__clip0_2145_55586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.867 15.836l8 6.388M28.267 9.715l2.933 6.654M14.533 28.612s4.667-.399 7.2 1.065M82.539 67.463l-2.127 19.313c-.175 1.588-1.661 2.897-3.384 2.708L66.69 88.35l3.192-28.97 6.759.741c3.71.407 6.291 3.77 5.898 7.342z",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.942 72.886l-1.53 13.89c-.175 1.588-1.66 2.897-3.384 2.708L66.69 88.35l1.866-16.933 13.386 1.47zM15.742 60.132l-2.128 19.314c-.175 1.587.99 3.188 2.713 3.377l10.338 1.134 3.191-28.97-6.76-.742c-3.71-.407-6.96 2.316-7.354 5.887z",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.144 65.556l-1.53 13.89c-.175 1.587.99 3.188 2.713 3.377l10.338 1.134 1.865-16.932-13.386-1.469zM47.6 25.551c4.8-7.852-6.267-14.772-.933-19.962 6.533-6.388 18 8.251 12.666 17.3",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.328 16.704c-14.314-1.57-27.26 8.79-28.833 23.077l-4.794 43.522c-.248 2.249 1.404 4.304 3.657 4.552l43.736 4.8c2.253.246 4.313-1.402 4.56-3.65l4.795-43.522c1.573-14.287-8.807-27.208-23.121-28.778z",
    fill: "#FFBF3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.506 81.969l32.603 3.578c1.59.174 2.914-.885 3.09-2.473l1.34-12.17c.612-5.556-3.413-10.416-8.847-11.012l-18.29-2.007a9.982 9.982 0 00-11.033 8.83l-1.34 12.17c-.16 1.456.886 2.91 2.477 3.084z",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.076 41.467l18.82 2.066c1.723.189 3.341-1.107 3.53-2.826.19-1.72-1.107-3.335-2.83-3.524l-18.82-2.065c-1.723-.19-3.341 1.106-3.53 2.825-.19 1.72 1.107 3.335 2.83 3.524z",
    fill: "#0C0A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.669 66.092c.973.91 2.461 2.01 4.538 2.64 4.92 1.611 8.289-.964 14.473-1.09 2.15-.031 5.345.186 9.086 1.534",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.87 76.987c.5-.882 1.057-2.294 1.261-4.145.219-1.985.01-3.748-.285-4.718",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "k12_svg__clip0_2145_55586"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
}

export default SvgK12;